import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination]);
$(document).ready(function () {
	$('.swiper-container.review-slider').each(function () {
		initSlide(this, {
			direction: 'vertical',
			loop: true,
		})
	})
	$('.swiper-container.slider').each(function () {
		initSlide(this, {
			slidesPerView: 2,
			spaceBetween: 12,
			breakpoints: {
				640: {
					slidesPerView: 3,
				},
				1024: {
					slidesPerView: 4,
				},
			},
		})
	})
	updateSliders()
})
// make sure slides fit window when all content has loaded
$(window).on('load', function () {
	updateSliders()
})

function initSlide (slide, userOptions) {
	let defaultOptions = {}
	let options = Object.assign({
		watchOverflow: true,
		observer: true,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		loop: false,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		scrollbar: {
			el: '.swiper-scrollbar',
		},
	}, (userOptions || defaultOptions))
	return new Swiper(slide, options)
}

export function makeSlider (className, options) {
	return initSlide(className, options)
}

function updateSliders () {
	window.dispatchEvent(new Event('resize'));
	$(window).trigger('resize');
	setTimeout(function () {
		// just to be sure
		window.dispatchEvent(new Event('resize'));
		$(window).trigger('resize');
	}, 300)
}

$(document).ready(function () {
	let height = 0
	$('.review-slider-inner').each(function () {
		height = Math.max(height, $(this).height())
	})
	$('.review-slider-wrapper').height(height)
})